'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIButton from 'UIComponents/button/UIButton';
import UILink from 'UIComponents/link/UILink';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIModal from 'UIComponents/dialog/UIModal';
import H2 from 'UIComponents/elements/headings/H2';
import { MODAL_WIDTH } from 'FileManagerCore/Constants';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function getI18nKey(suffix) {
  return `FileManagerDashboard.video2LimitReachedModal.${suffix}`;
}
export default class Video2LimitReachedModal extends Component {
  renderCapacityPackDetails() {
    const {
      quantityAllowed,
      quantityUsed
    } = this.props;
    const isCloseToLimit = quantityUsed > quantityAllowed && quantityUsed < quantityAllowed + 5;
    return /*#__PURE__*/_jsx("div", {
      className: "m-top-3",
      children: isCloseToLimit ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: getI18nKey('messagePart3Upgrade_jsx'),
        options: {
          videoPacksHref: 'hubspot.com'
        },
        elements: {
          Link: UILink
        }
      }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: getI18nKey('messagePart3Dowgrade_jsx'),
        options: {
          videoDowngradesHref: 'hubspot.com'
        },
        elements: {
          Link: UILink
        }
      })
    });
  }
  render() {
    const {
      onClose,
      projectedNumber,
      quantityAllowed,
      quantityUsed,
      uploadingVideoCount
    } = this.props;
    return /*#__PURE__*/_jsxs(UIModal, {
      use: "success",
      width: MODAL_WIDTH,
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: onClose
        }), /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: getI18nKey('title'),
            options: {
              count: uploadingVideoCount
            }
          })
        })]
      }), /*#__PURE__*/_jsx(UIDialogBody, {
        children: /*#__PURE__*/_jsxs("div", {
          className: "m-y-6",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: getI18nKey('messagePart1'),
            options: {
              projectedNumber,
              quantityAllowed
            }
          }), quantityAllowed <= quantityUsed && /*#__PURE__*/_jsx("span", {
            className: "m-left-1",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: getI18nKey('messagePart2.allVideosUploadedWithNoAdvFeatures'),
              options: {
                count: uploadingVideoCount
              }
            })
          }), quantityUsed < quantityAllowed && /*#__PURE__*/_jsx(FormattedMessage, {
            message: getI18nKey('messagePart2.someVideosUploadedWithNoAdvFeatures'),
            options: {
              uploadingVideoCount,
              newlyUploadedVideosWithAdvancedFeatures: quantityAllowed - quantityUsed
            }
          }), this.renderCapacityPackDetails()]
        })
      }), /*#__PURE__*/_jsx(UIDialogFooter, {
        children: /*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          onClick: onClose,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: getI18nKey('close')
          })
        })
      })]
    });
  }
}
Video2LimitReachedModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  projectedNumber: PropTypes.number.isRequired,
  quantityUsed: PropTypes.number.isRequired,
  quantityAllowed: PropTypes.number.isRequired,
  uploadingVideoCount: PropTypes.number.isRequired
};